<template>
  <div id="jumbotron">
    <div class="overlay"></div> <!-- Blue blur overlay -->
    <div class="container content">
      <p class="title tf-dm-serif" v-html="$t('contactUsPage.title')"></p>
    </div>
  </div>
  <div class="container pt-5">
    <div class="row flex-row-reverse">
      <div class="col-12 col-md-6 col-lg-5">
        <div class="shop-photo">
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/frontal-photo.webp" 
            alt="English Matters, Petaling Jaya" width="350px" class="rounded w-100">
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-7">
        <div id="contact" class="row">
          <div class="col-12 col-lg-6 mb-5">
            <p class="title"><i class="bi bi-geo-alt-fill"></i></p>
            <p class="text-primary fw-bold">English Matters Language Centre</p>
            <p>
              No.1-3, 2nd Floor,
              <br>Jalan SS 23/15, Taman SEA,
              <br>47400 Petaling Jaya, Selangor,
              <br>Malaysia
            </p>
          </div>
          <div class="col-12 col-lg-6 mb-5">
            <p class="title"><i class="bi bi-chat-dots-fill"></i></p>
            <p class="text-primary fw-bold">+6017 380 7335</p>
            <p><strong>{{ $t('contactUsPage.centreDirector') }}</strong>: Nicholas Chan</p>

            <div>
							<span class="me-3">
                <a class="text-dark" href="https://www.facebook.com/UKEngMatters" target="_blank">
                  <i class="bi bi-facebook"></i>
                </a>
              </span>
              <span class="me-3">
                <a class="text-dark" href="https://www.instagram.com/UKEngMatters" target="_blank">
                  <i class="bi bi-instagram"></i>  
                </a>
              </span>
              <span class="me-3">
                <a class="text-dark" href="https://www.twitter.com/UKEngMatters" target="_blank">
                  <i class="bi bi-twitter-x"></i>  
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="contactForm">
    <div id="form-container"></div>
  </div>
  <div>
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3983.9195770315687!2d101.60958297467602!3d3.1159776968595616!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc4eabb1d84e95%3A0xe178294f469b9a52!2sEnglish%20Matters!5e0!3m2!1sen!2smy!4v1741792093388!5m2!1sen!2smy" width="100%  " height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
  </div>
</template>

<script>
export default {
  mounted() {
    this.loadActiveCampaignForm();
  },
  methods: {
    loadActiveCampaignForm() {
      // Remove existing script if any
      const existingScript = document.querySelector("#activecampaign-script");
      if (existingScript) {
        existingScript.remove();
      }
      const existingForm = document.querySelector("#_form_67D04DD803A9B_");
      if (existingForm) {
        existingForm.remove();
      }

      // Create the script
      const script = document.createElement("script");
      script.id = "activecampaign-script";
      script.src = "https://scholarships2u.activehosted.com/f/embed.php?id=75";
      script.type = "text/javascript";
      script.charset = "utf-8";
      script.async = true;
      document.body.appendChild(script);

      // Observe the DOM and move the form when it appears
      const observer = new MutationObserver(() => {
        let formContent = document.querySelector("[id^='_form_']");
        let container = document.querySelector("#form-container");

        if (formContent && container && !container.contains(formContent)) {
          container.appendChild(formContent);
          observer.disconnect(); // Stop observing once moved
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    },
  },
};
</script>

<style scoped>
  #jumbotron {
    position: relative;
    background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/banner-buiding.webp");
    background-size: cover;
    background-position: center;
    height: 60vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Blue blurry overlay */
  #jumbotron .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(19, 5, 115, 0.75); /* Blue tint */
  }

  #jumbotron .content {
    position: relative;
    z-index: 2;
  }

  #jumbotron .title {
    color: white;
    font-size: 4em;
  }

  #contact {
    font-size: 18px;
  }
  #contact .title {
    color: #FF4d37;
    font-size: 3em;
  }

  .shop-photo {
    max-width: 80%;
    margin: auto;
  }

  #contactForm {
    background-color: #F4F3F9;
  }
</style>
